import { render, staticRenderFns } from "./BookDemo.vue?vue&type=template&id=5647a6ca&scoped=true&"
import script from "./BookDemo.vue?vue&type=script&lang=js&"
export * from "./BookDemo.vue?vue&type=script&lang=js&"
import style0 from "./BookDemo.vue?vue&type=style&index=0&id=5647a6ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5647a6ca",
  null
  
)

export default component.exports